define(function(require,exports,module){
    var sqrt    = Math.sqrt,
        min     = Math.min,
        max     = Math.max,
        power   = Math.pow,
        abs     = Math.abs,
        classify = require( "es6ish-class/es6ish-class" ),
        precision = require( '../math/precision' );


    function positionAtTime(p) {
        var p0 = p + '0',
            vp0 = 'v' + p0,
            ap = 'a' + p;

        return function (t) {
            return !isNaN(this.coords[p0]) && (this.coords[p0] + (this.coords[vp0] * t) + ((0.5 * this.coords[ap]) * (t * t))) || this.coords[p];
        }
    }

    function PitchRaster(pitch,renderer){
        this.pitch=pitch;
        this.coords = pitch.coords;
        this.renderer=renderer;
    }

    classify(PitchRaster);
    PitchRaster.prototype = {
        curveAtTime : function(t, coord) {
            var coords = this.coords;
            return coords['v' + coord + '0'] + coords['a' + coord] * t;
        },
        xPositionAtTime : positionAtTime('x'),
        // Use Z as Y when converting from pfx coords
        yPositionAtTime : positionAtTime('z'),
        // Use -Y as Z when converting from pfx coords
        zPositionAtTime : (function(t){
            var getZ=positionAtTime('y');

            return function(t){
                    // Negate Z
                return -1 * getZ.call(this,t);
            }
        })(),
        timeAtYPosition : function(yPosition) {
            var a = (-1.0 * this.coords.vy0),
                b = sqrt(this.coords.vy0 * this.coords.vy0 - 2 * this.coords.ay * (this.coords.y0 - yPosition));

            var time1 = (a + b) / this.coords.ay,
                time2 = (a - b) / this.coords.ay;

            return min(time1, time2);
        },

        pointOnGrid : function(x,y,z){
            var scalers=this.renderer.scalers,
                rayWidth;

            // Adjust y to be in the middle of the screen(camera is centered vertically)
            var newY = (((scalers.height - scalers.viewBottomMargin) / scalers.y) * scalers.y_center) - y,
            // Give the x,y perspective courtesy of z
                perspectiveX = x * (scalers.eyetoScreen / abs(scalers.eyetoScreen - z)),
                perspectiveY = newY * (scalers.eyetoScreen / abs(scalers.eyetoScreen - z)),
                perspectiveRad = (x + (scalers.ballSize/12)/2) * (scalers.eyetoScreen / abs(scalers.eyetoScreen - z));

            // Put x,y into the view space taking into account its size
            var screenX = perspectiveX * scalers.x + (scalers.width * scalers.x_center),
                screenY = perspectiveY * scalers.y + (scalers.height * scalers.y_center) - scalers.viewBottomMargin  + scalers.y_offset,
                screenRad = perspectiveRad * scalers.x + (scalers.width * scalers.x_center),
                safeXY = this.ensureBounds(screenX, screenY);
            // [0: x, 1: y, 2: z, 3: width, 4: radius]
            return [ precision(safeXY.x), precision(safeXY.y ), precision(z * scalers.x - scalers.viewBottomMargin),0.1, screenRad - screenX];
        },
        ensureBounds : function(x, y, clip){
            var scalers = this.renderer.scalers,
                bounds = clip !== true ? scalers.fullBounds : scalers.bounds;

            // Make sure its in the bounds
            if(x < bounds.left){
                x = bounds.left;
            } else if (x > bounds.right){
                x = bounds.right;
            }
            if(y < bounds.top){
                y = bounds.top;
            } else if (y > bounds.bottom){
                y = bounds.bottom;
            }
            return {x : x, y : y};
        },
        points3D : function (time,step,numberOfPoints) {
            var x = this.xPositionAtTime(time),
                y = this.yPositionAtTime(time),
                z = this.zPositionAtTime(time)||0.1,
                scalers=this.renderer.scalers,
                point;

            var widthAdjuster = power(step, 2);
            var pitch = this.pitch;
            var ballRatio = 1.8;
            var startSpeed = pitch.startSpeed || 95;
            var endSpeed = pitch.endSpeed || (startSpeed * 0.92);

            var speedChange = (startSpeed - endSpeed);
            var sizer = min;
            if (y <= 0.01) {
                // If y value is below 0.01, we've hit the ground before the strikezone
                this.pitch.ballInDirt = true;
                return null;
            }

            if(scalers.perspective === 'pitcher') {
                x = x * -1;
                widthAdjuster = power((scalers.ballRadius) / speedChange / step * numberOfPoints, 2);
                ballRatio = 1;
            } else {
                widthAdjuster = power((scalers.ballRadius) / speedChange / numberOfPoints * power(step, 2), 0.8);
            }

            point=this.pointOnGrid(x,y,z);
            point[3]=sizer(widthAdjuster, scalers.maxlinewidth);

            return point;
        },

        points2D : function () {
            var x = this.coords.x,
                y = this.coords.y;
            var scalers = this.renderer.scalers;
            var perspectiveAdjust = 1;

            if (scalers.perspective === 'pitcher') {
                perspectiveAdjust = -1
            }

            var screenX = perspectiveAdjust * ((-x/scalers.pixelFoot + scalers.adjust2d.x) * scalers.adjust2d.x),
                screenY = ((-y + scalers.perspectiveShiftY + scalers.interpolatedPlateFront)/scalers.pixelFoot)*scalers.adjust2d.y,
                safeXY = this.pointOnGrid(screenX, screenY ,0);

            return safeXY;
        }
    }

    return PitchRaster;
});
